
class PaginationNavigation{
	constructor(el){
		this.el = el;
	}
	init(){
		let prevLink = this.previousLinkEl;
		let nextLink = this.nextLinkEl;
		if(this.pageNum==1){
			prevLink.classList.add("disabled");
			prevLink.addEventListener('click', function (event) {
			  event.preventDefault();
			});
		}

		if(this.pageNum==this.totalPages){
			nextLink.classList.add("disabled");
			nextLink.addEventListener('click', function (event) {
			  event.preventDefault();
			});
		}
	}

	createSpanContainer(text){
		let spanNode = document.createElement('span');
		spanNode.innerHTML = text;
		return spanNode;
	}

	createContainer(link){
		let container = document.createElement('div');
		container.classList.add('nav-button-container');
		container.appendChild(link);
		return container;
	}
	get pageNavs(){
		return this.el.querySelector('#new-page-nav-text');
	}
	get previousLinkEl(){
		return this.el.querySelector('#previous-section > a');
	}
	get nextLinkEl(){
		return this.el.querySelector('#next-section > a');
	}

	get pageNum(){
		let page = document.location.pathname.split("/").pop();
		let pageNum = page.split("_")[1] ? page.split("_")[1].replace(/\?.*/,'') : 1;
		if(window.s_pagenum && pageNum == window.s_pagenum){
			return window.s_pagenum;
		}else if(pageNum){
			return pageNum;
		}
		return window.s_pagenum ? parseInt(window.s_pagenum) : pageNum;
	}
	get totalPages(){
		return this.pageNavs.childElementCount || 1;
	}
}

export {PaginationNavigation}